let initDataRaw = ''

export async function initTelegram() {
  try {
    const sdk = await import('@tma.js/sdk')
    const launchQuery = window.location.href.replace(/^[^?#]*[?#]/, '').replace(/[?#]/g, '&')
    initDataRaw = new URLSearchParams(launchQuery).get('tgWebAppData') ?? sdk.retrieveRawInitData() ?? ''
    try {
      sdk.init()
      if (sdk.viewport.mount.isAvailable()) {
        await sdk.viewport.mount()
        sdk.viewport.bindCssVars()
      }
      if (sdk.backButton.mount.isAvailable()) sdk.backButton.mount()
      document.documentElement.dataset.telegram = 'true'
    } catch {
      document.documentElement.dataset.telegram = 'false'
    }
  } catch {
    document.documentElement.dataset.telegram = 'false'
  }
  return initDataRaw
}

export function getInitData() { return initDataRaw }

export async function setTelegramBackButton(visible: boolean, handler: () => void) {
  try {
    const { backButton } = await import('@tma.js/sdk')
    if (!backButton.isMounted()) backButton.mount()
    if (visible) {
      backButton.show()
      return backButton.onClick(handler)
    }
    backButton.hide()
  } catch { /* Browser mock has no BackButton. */ }
  return () => undefined
}

export async function haptic(kind: 'light' | 'success' = 'light') {
  try {
    const { hapticFeedback } = await import('@tma.js/sdk')
    if (kind === 'success' && hapticFeedback.notificationOccurred.isAvailable()) hapticFeedback.notificationOccurred('success')
    else if (hapticFeedback.impactOccurred.isAvailable()) hapticFeedback.impactOccurred('light')
  } catch { /* no-op outside Telegram */ }
}
